import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-status-label',
  templateUrl: './status-label.component.html',
  styleUrls: ['./status-label.component.scss']
})
export class StatusLabelComponent {
  @Input() icon: string;
  @Input() cssClasses: string;
  @Input() statusLabelText: string;
}
